import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { TimeTracks } from "./TimeTracks";
import TimeTracksQueryNode, {
  type TimeTracksQuery$variables,
} from "./__generated__/TimeTracksQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof TimeTracks> = {
  root: JSResource("TimeTracks", () =>
    import("./TimeTracks").then((module) => module.TimeTracks),
  ),
  getPreloadProps({ params }) {
    const variables: TimeTracksQuery$variables = {
      username: params.id!,
    };

    return {
      queries: {
        query: {
          parameters: TimeTracksQueryNode,
          variables,
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
